import { render, staticRenderFns } from "./newRulesDetails.vue?vue&type=template&id=258fd978&scoped=true"
import script from "./newRulesDetails.vue?vue&type=script&lang=js"
export * from "./newRulesDetails.vue?vue&type=script&lang=js"
import style0 from "./newRulesDetails.vue?vue&type=style&index=0&id=258fd978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258fd978",
  null
  
)

export default component.exports